import React, { useState, useEffect } from "react";
import InputRange from "react-input-range";
import { isMobile } from "react-device-detect";

const InputRangeSlider = (props) => {
  let daysBetweenPeriod = !isNaN(props.daysBetweenPeriod)
    ? props.daysBetweenPeriod
    : props.daysBetweenPeriodsDefaults.default;
  const [daysBetweenPeriods, setDaysBetweenPeriods] = useState("");
  const [minValue, setMinValue] = useState(
    Number(props.daysBetweenPeriodsDefaults.minimumValue)
  );
  const [maxValue, setMaxValue] = useState(
    Number(props.daysBetweenPeriodsDefaults.maximumValue)
  );

  useEffect(() => {
    props.setDaysBetweenPeriod(daysBetweenPeriod);
    setDaysBetweenPeriods(daysBetweenPeriod);
  }, []);

  const handleChange = (event) => {
    let rangeSlectorValue = event;
    props.setDaysBetweenPeriod(rangeSlectorValue);
    setDaysBetweenPeriods(rangeSlectorValue);
  };

  const handleChangeComplete = (event) => {
    props.setDaysBetweenPeriod(event);
    if (props.index < 2) {
      props.setdivdaysBetweenPeriod(false);
      props.setdivperiodDuration(true);
    }
  };

  return (
    <>
      {!isMobile && (
        <div className="period-range-wrap">
          <InputRange
            className="cycle-length"
            maxValue={maxValue}
            minValue={minValue}
            value={daysBetweenPeriods}
            onChange={handleChange}
            onChangeComplete={handleChangeComplete}
          />
        </div>
      )}
      {isMobile && (
        <div className="period-range-wrap">
          <div className="row text-center">
            <div className="col-12 my-4">
              <span>Number of Days</span>
            </div>
            <div className="col-12 mt-5">
              <InputRange
                className="cycle-length"
                maxValue={maxValue}
                minValue={minValue}
                value={daysBetweenPeriods}
                onChange={handleChange}
                onChangeComplete={handleChangeComplete}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InputRangeSlider;
